import { Mode, Skin } from '@webbyx/mui';

/**
 * ===========================
 * MAIN
 * ===========================
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createThemeOverrideTable = (mode: Mode, skin: Skin) => {
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head":  {
            background: '#F7F7F9 !important',
            fontWeight: 600,
            whiteSpace: 'nowrap'
          }
        }
      }
    },
  };
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default createThemeOverrideTable;
